import { buffers, END, eventChannel } from 'redux-saga';
import { getApiUrl, getToken } from 'utils/request';

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => {
      resolve((fr.result as string).split(',')[1]);
    };
    fr.readAsDataURL(file);
  });
}

/**
 * A failed upload's error: the API's message, or a fallback for a body that
 * isn't JSON (e.g. a load balancer's 502/413 page) or no response at all
 * (code 0). Parsing such a body used to throw, so nothing was reported and
 * the upload's spinner never stopped.
 */
export function uploadError(
  response: string,
  status: number,
): { message: string; code: number } {
  try {
    const body = JSON.parse(response || '{}');
    if (body?.message) {
      return { message: body.message, code: status };
    }
  } catch (e) {
    // Not JSON: fall through.
  }

  return status
    ? { message: `The upload failed (${status}).`, code: status }
    : {
        message:
          "Couldn't reach the server. Check your connection and try again.",
        code: 0,
      };
}

// TODO - no point in having this removed from the axios request logic - reintegrate

export function createUploadFileChannel(
  endpoint: string,
  payload: any,
  method: string = 'POST',
) {
  return eventChannel(emitter => {
    const xhr = new XMLHttpRequest();
    xhr.timeout = 1000 * 60 * 15;
    const onProgress = (e: ProgressEvent) => {
      if (e.lengthComputable) {
        const progress = e.loaded / e.total;
        emitter({ progress });
      }
    };

    const sendFailed = ({ message = 'Upload failed', code = 500 }) => {
      emitter({ err: { message, code } });
      emitter(END);
    };

    const onFailure = (e: ProgressEvent) => {
      sendFailed({ message: 'Upload failed' });
    };
    xhr.upload.addEventListener('progress', onProgress);
    // xhr.upload.addEventListener('error', onFailure);
    //  xhr.upload.addEventListener('abort', onFailure);
    xhr.onreadystatechange = () => {
      const { readyState, status, response } = xhr;
      if (readyState === 4) {
        if (status === 200 || status === 201) {
          emitter({ success: true, response });
          emitter(END);
        } else {
          sendFailed(uploadError(response, status));
        }
      }
    };

    xhr.open(method, getApiUrl(endpoint), true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + getToken());
    xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

    xhr.send(JSON.stringify(payload));
    return () => {
      xhr.upload.removeEventListener('progress', onProgress);
      xhr.upload.removeEventListener('error', onFailure);
      xhr.upload.removeEventListener('abort', onFailure);
      xhr.onreadystatechange = null;
      xhr.abort();
    };
  }, buffers.sliding(2));
}
